import styled from 'styled-components'
import ColorConfig from '../../config/ColorConfig'

interface Props {
	height?: number
	isNotHover?: boolean
    backgroundColor?: 'card' | 'card-card'
}

const ContentContainer = styled.a.attrs<Props>({
	className: 'clickable',
})`
	display: flex;
	flex-direction: row;

	position: relative;

	gap: 20px;
	padding: 20px;
	border-radius: 16px;
	background-color: ${props => props.backgroundColor == 'card-card' ? 'var(--card-card-bg-color)' : 'var(--card-bg-color)'};
	box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
	height: ${props => props.height}px;

	&:hover {
		color: ${props => (props.isNotHover ? 'black' : ColorConfig.Primary)};
	}
`

export default ContentContainer
